var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedIn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "linkedIn_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.407 4.6a.796.796 0 0 0-.807.783v9.36c0 .432.362.782.807.782h9.31c.447 0 .808-.35.808-.783v-9.36a.795.795 0 0 0-.807-.782zM7.92 8.824v4.919H6.285V8.824zm.108-1.52c0 .471-.355.849-.925.849h-.01c-.55 0-.904-.378-.904-.85 0-.483.365-.85.925-.85.559 0 .903.367.914.85m2.432 6.439H8.825s.021-4.457 0-4.918h1.635v.696c.217-.335.606-.812 1.473-.812 1.076 0 1.882.703 1.882 2.214v2.82H12.18v-2.631c0-.661-.236-1.112-.828-1.112-.452 0-.72.304-.839.598a1.1 1.1 0 0 0-.053.398z",
  clipRule: "evenodd"
})));
export default SvgLinkedIn;